import { createRouter, createWebHistory } from "vue-router";
import LoginVue from "@/views/LoginVue.vue";
import LoginEnterprises from "@/views/LoginEnterprises.vue";
import AdminHomeView from "@/views/admin/HomeView.vue";
import LoginColaborators from "@/views/LoginColaborators.vue";
import { adminGuard } from "./guard/adminGuard";
import { companyGuard } from "./guard/companyGuard";
import { collaboratorAccessGuard } from "./guard/collaboratorAccessGuard";
import { collaboratorFlowGuard } from "./guard/collaboratorFlowGuard";
import CollabEntryView from "@/views/collaborator/CollabEntryView.vue";
import CollaboratorFormView from "@/views/collaborator/CollaboratorFormView.vue";

const routes = [
  // admin
  {
    path: "/",
    name: "login",
    component: LoginVue,
    meta: { title: "" },
  },
  {
    path: "/admin",
    // component: () => import("@/layouts/AdminLayout.vue"),
    beforeEnter: adminGuard,
    children: [
      {
        path: "home",
        name: "adm-home",
        component: AdminHomeView,
        meta: { title: "Inicio" },
      },
      {
        path: "enterprises",
        name: "comp",
        meta: { title: "Empresas" },
        component: () =>
          import(
            /* webpackChunkName: "comp" */ "../views/admin/EnterprisesView.vue"
          ),
      },
    ],
  },

  // enterprises
  {
    path: "/empresa",
    name: "login-comp",
    component: LoginEnterprises,
    meta: { title: "Acesso Empresa" },
  },
  {
    path: "/empresa/home",
    name: "enter",
    beforeEnter: companyGuard,
    meta: { title: "Inicio" },
    component: () =>
      import(
        /* webpackChunkName: "empresa-qr" */ "../views/enterprises/EnterpriseHomeView.vue"
      ),
  },
  {
    path: "/empresa/form",
    name: "enter-form",
    beforeEnter: companyGuard,
    meta: { title: "Formulário" },
    component: () =>
      import(
        /* webpackChunkName: "empresa-qr" */ "../views/enterprises/EnterpriseDescriptionView.vue"
      ),
  },

  // colaborators
  {
    path: "/r/:token",
    name: "collab-entry",
    component: CollabEntryView,
    meta: { title: "Verificando..." },
  },
  {
    path: "/collab",
    name: "login-collab",
    beforeEnter: collaboratorAccessGuard,
    component: LoginColaborators,
    meta: { title: "Acesso Colaborador" },
  },
  {
    path: "/collab/form",
    name: "collab-form",
    beforeEnter: collaboratorFlowGuard,
    component: CollaboratorFormView,
    meta: { title: "Formulário" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  const baseTitle = "X Mind";
  document.title = to.meta?.title
    ? `${baseTitle} - ${to.meta.title}`
    : baseTitle;
});

export default router;
